import React from "react";
import { round } from "lodash";

import NutrientInput from "../../../../parts/inputs/nutrient-input";

const NutrientsInputs = ({
  handleChange,
  proteins = 0,
  carbs = 0,
  fats = 0,
  isRestDay = false,
}) => {
  const caloriesName = isRestDay ? "restDayCalories" : "calories";

  const onProteinsChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    if (Number(value)) {
      updates[caloriesName] = round(
        Number(value) * 4 + Number(carbs) * 4 + Number(fats) * 9,
        1
      );
    }

    handleChange(e, updates);
  };

  const onCarbsChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    if (Number(value)) {
      updates[caloriesName] = round(
        Number(proteins) * 4 + Number(value) * 4 + Number(fats) * 9,
        1
      );
    }

    handleChange(e, updates);
  };

  const onFatsChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    if (Number(value)) {
      updates[caloriesName] = round(
        Number(proteins) * 4 + Number(carbs) * 4 + Number(value) * 9,
        1
      );
    }

    handleChange(e, updates);
  };

  return [
    <div className="form-row !mt-0">
      <div className="form-col">
        <input
          name={isRestDay ? "restDayCalories" : "calories"}
          type="number"
          className="text-input"
          hidden
        />
      </div>
    </div>,

    <div className="form-col">
      <div className="form-col">
        <label className="label proteins req" htmlFor="proteins">
          Protein (1g = 4kCal)
        </label>
        <NutrientInput
          name={isRestDay ? "restDayProteins" : "proteins"}
          suffix="g"
          value={proteins}
          onChange={onProteinsChange}
        />
      </div>
      <div className="form-col">
        <label className="label carbs req" htmlFor="carbs">
          Carbs (1g = 4kCal)
        </label>
        <NutrientInput
          name={isRestDay ? "restDayCarbs" : "carbs"}
          suffix="g"
          value={carbs}
          onChange={onCarbsChange}
        />
      </div>
    </div>,

    <div className="form-col">
      <div className="form-col">
        <label className="label fats req" htmlFor="fats">
          Fat (1g = 9kCal)
        </label>
        <NutrientInput
          name={isRestDay ? "restDayFats" : "fats"}
          suffix="g"
          value={fats}
          onChange={onFatsChange}
        />
      </div>
      <div className="form-col">
        <label className="label fibers" htmlFor="fibers">
          Fiber (Optional)
        </label>
        <NutrientInput
          name={isRestDay ? "restDayFibers" : "fibers"}
          suffix="g"
          onChange={handleChange}
        />
      </div>
    </div>,
  ];
};

export default NutrientsInputs;
